import { STORAGE, useLocalStorageStore } from '@/store';

export interface INDBFlow {
  isNDBFlow?: boolean | null;
  isNDBEmailVerifiedShown?: boolean | null;
  isNDBEmailConfirmShown?: boolean | null;
  isNDBPlayForRealShown?: boolean | null;
  isPendingOAuthNDBRedirect?: boolean | null;
}

export const saveLocalNDBFlow = (partial: Partial<INDBFlow>) => {
  const store = useLocalStorageStore.getState();
  const localNDBFlow = store.get<INDBFlow | null>(STORAGE.NDB_FLOW) ?? {};

  store.replace(STORAGE.NDB_FLOW, {
    ...localNDBFlow,
    ...partial,
  });
};
